import React from 'react'
import { Dialog, DialogTitle } from '@mui/material'
import { useState, useEffect } from 'react'
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PdfPreview from './PdfPreview';
import MDButton from "components/MDButton";

const FilePopUp = ({ entry, ShowFile, setShowFile }) => {
    console.log(entry)
    // const [ShowFile, setShowShowFile] = useState(false)
    const getFileDiv = (entry) => {
        if (entry?.fileUrl != null) {
            return (
             getFileElement(entry, true)
            )
        }
        else if (entry?.getEntryFiles?.length > 0) {
            return entry.getEntryFiles.map((file) => (
             
                        getFileElement(file, false)
             
            ))
        }
        else {
            return <div></div>
        }
    }

    const getFileElement = (file, isCloud) => {
        if (isCloud) {
            if (file?.fileType == null || file?.fileType?.startsWith('image/')) {
                return (
                        <img
                            src={file.fileUrl}
                            
                        />
                )
            }
            else if (file?.fileType?.startsWith('video/')) {
                return (
                        <video
                            src={file.fileUrl}
                            controls

                         
                        />
                )
            }
            //pdf
            else if(file.fileType.startsWith('application/pdf')){
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <div style={{ border: '1px solid #0000001c', textAlign: "center" }}  onClick={() => setShowFile(true)}>
                            <PdfPreview fileUrl={file.fileUrl} />
                        </div>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                       
                    </div>
                )
            }
            else {
                return (
                    <>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file?.fileName}</MDTypography>
                        <MDButton
                            onClick={() => {
                                DownloadFileClick(file.id, file.fileName);
                            }}
                            fontWeight="medium"
                        >
                            Download
                        </MDButton>
                    </>
                )
            }
        }
        else {
            if (file?.fileType?.startsWith('image/')) {
                return (
                    <div style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <img
                            src={"data:image/png;base64," + file?.file}
                            // alt={file?.fileName}
                        />
                    </div>
                )
            }
            else if (file?.fileType?.startsWith('video/')) {
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <video
                            src={"data:video/mp4;base64," + file?.file}
                            
                        />
                    </div>
                )
            }
            else {
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                        <MDButton
                            onClick={() => {
                                DownloadFileClick(file.id, file.fileName);
                            }}
                            fontWeight="medium"
                        >
                            Download
                        </MDButton>
                    </div>
                )
            }
        }
    }

    return (
        <Dialog className='FilePopUp' fullWidth id="FilePopUp" maxWidth="6000px" fullScreen sx={{
            borderRadius: '10px'
        }}
            open={ShowFile} onClose={() => setShowFile(false)}>
            <div className="FilePopUpBody">
                {
                    getFileDiv(entry)
                }
            </div>
        </Dialog>
    )
}

export default FilePopUp